import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import {
	mediaBreakpointLowerThanMd,
	tabletBreakpoint,
} from 'core/layouts/ui-blocks/ReusableStyles';

export const appBarStyles = {
	// app-bar
	appBarWrapper: {
		width: '100%',
		height: 'fit-content',
		padding: { xs: '8px', [tabletBreakpoint]: '8px 16px' },
		borderWidth: { xs: 0, [tabletBreakpoint]: '0 0 1px 0' },
		borderStyle: 'solid',
		borderColor: 'colors.dark3',

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		backgroundColor: 'colors.dark6',
	},

	shuttingDownContainerMobile: {
		justifyContent: 'center',
		maxWidth: '536px',
		padding: '8px 12px',
		minWidth: '333px',
	},
	topHeader: {
		width: '100%',

		display: 'flex',
		flexDirection: { xs: 'column', [tabletBreakpoint]: 'row' },
		alignItems: 'center',
		justifyContent: 'center',

		position: 'relative',

		[mediaBreakpointLowerThanMd]: {
			padding: 0,
		},
	},
	appBar: {
		width: '100%',
		padding: { xs: '0 16px', [tabletBreakpoint]: '0 24px' },

		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',

		position: 'relative',
		gap: { xs: '20px', md: '70px' },
	},
	appBarLogoCont: {
		height: { xs: '20px', [tabletBreakpoint]: '20px' },
		cursor: 'pointer',

		'& svg': { height: '100%', width: 'auto' },
	},

	appBarTextButton: {
		minWidth: 'unset',
		gap: '4px',
		textTransform: 'none',
		'& svg': { height: '24px', width: 'auto' },
	},
	appBarGuide: (showGuide) => ({
		padding: '4px 12px',
		backgroundColor: showGuide ? 'colors.dark6' : 'colors.dark4',
		border: `1px solid ${colorPalette.dark2}`,
		borderRadius: '20px',
		cursor: 'pointer',
	}),
};
